<template>
    <div class="sip-view-page">
        <div class="nk-block-head nk-block-head-sm sip-view-head">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{ trans('locale.translation') }}</h3>
                    <div class="nk-block-des text-soft">
                        <p>{{ trans('locale.locale') }} · {{ getName(module) }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="locale"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner admin-config-panel__inner--wide sip-view-card">
                    <div class="row">
                        <div class="col-12 col-lg-3 mb-3 mb-lg-0">
                            <nav class="admin-config-module-nav" :aria-label="trans('locale.module')">
                            <router-link
                                v-for="mdl in modules"
                                :key="mdl"
                                :to="getModuleLink(mdl)"
                                exact
                                class="admin-config-module-nav__link"
                                :class="{ 'admin-config-module-nav__link--active': mdl === module }"
                            >
                                {{ getName(mdl) }}
                            </router-link>
                            </nav>
                        </div>
                        <div class="col-12 col-lg-9">
                            <show-tip module="locale" tip="tip_translation"></show-tip>
                            <section class="sip-view-section" :aria-label="trans('locale.translation')">
                            <div v-if="getWordCount">
                                <div v-for="(word,index) in words" :key="index">
                                    <div v-if="typeof word === 'object'">
                                        <div class="form-group" v-for="(wrd,i) in word" :key="`${index}_${i}`">
                                            <label for="">{{trans(module+'.'+index+'.'+i)}}</label>
                                            <input class="form-control" type="text" value="" v-model="words[index][i]" :name="`${index}_${i}`">
                                        </div>
                                    </div>
                                    <div class="form-group" v-else>
                                        <label for="">{{trans(module+'.'+index)}}</label>
                                        <input class="form-control" type="text" value="" v-model="words[index]" :name="index">
                                    </div>
                                </div>
                                <div class="admin-config-actions">
                                    <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" @click="saveTranslation">{{ trans('general.save') }}</button>
                                </div>
                            </div>
                            <div v-else>
                                <p class="sip-view-note mb-0">{{ trans('general.no_result_found') }}</p>
                            </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import configurationSidebar from '../system-config-sidebar'

    export default {
        components: { configurationSidebar },
        data() {
            return {
                modules: {},
                words: {},
                module: (this.$route.params.module) ? this.$route.params.module : 'auth'
            };
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('multilingual')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.fetchWords();
        },
        methods: {
            fetchWords(){
                axios.post('/api/locale/fetch',{
                    locale: this.$route.params.locale,
                    module: this.module
                    })
                    .then(response => response.data)
                    .then(response => {
                        this.modules = response.modules,
                        this.words = response.words
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getName(name){
                name = helper.ucword(name);
                return name.replace(/_/g, ' ');
            },
            getModuleLink(module){
                return '/configuration/locale/'+this.$route.params.locale+'/'+module
            },
            saveTranslation(){
                axios.post('/api/locale/translate',{
                    locale: this.$route.params.locale,
                    module: this.module,
                    words: this.words
                }).then(response => response.data)
                .then(response => {
                    toastr.success(response.message);
                }).catch(error => {
                    helper.showDataErrorMsg(error);
                });
            }
        },
        watch: {
            '$route.params.module'(newModule, oldModule) {
                this.module = newModule;
                this.fetchWords();
            }
        },
        computed: {
            getWordCount(){
                return _size(this.words);
            }
        }
    }
</script>

<style scoped>
.admin-config-module-nav {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    padding: 0.35rem;
    background: #ffffff;
    border: 1px solid #e6e9ef;
    border-radius: 8px;
}

.admin-config-module-nav__link {
    display: block;
    padding: 0.45rem 0.65rem;
    border: 0;
    border-radius: 6px;
    color: #475569;
    font-size: 0.8125rem;
    font-weight: 600;
    text-decoration: none;
}

.admin-config-module-nav__link:hover {
    background: #f8fafc;
    color: #0f172a;
    text-decoration: none;
}

.admin-config-module-nav__link--active {
    background: #e8f1fb;
    color: #206bc4;
}
</style>
